export const GET_PROVIDERS_OUTSTANDING_REQUEST = 'GET_PROVIDERS_OUTSTANDING_REQUEST';
export const GET_PROVIDERS_OUTSTANDING_RESPONSE = 'GET_PROVIDERS_OUTSTANDING_RESPONSE';

export const GET_TRANSACTIONS_REQUEST = 'GET_TRANSACTIONS_REQUEST';
export const GET_TRANSACTIONS_RESPONSE = 'GET_TRANSACTIONS_RESPONSE';

export const CREATE_SETTLEMENT = 'CREATE_SETTLEMENT';

export const GET_SETTLEMENTS_REQUEST = 'GET_SETTLEMENTS_REQUEST';
export const GET_SETTLEMENTS_RESPONSE = 'GET_SETTLEMENTS_RESPONSE';

export const EXPORT_SETTLEMENTS = 'EXPORT_SETTLEMENTS';

export const GET_REQUEST_STATUS = "GET_REQUEST_STATUS";

export const GET_FIXED_COMMISSION_FEES_REQUEST = 'GET_FIXED_COMMISSION_FEES_REQUEST';
export const GET_FIXED_COMMISSION_FEES_RESPONSE = 'GET_FIXED_COMMISSION_FEES_RESPONSE';
